/**
 * What actually happened to one suggested test the user asked IntelliCatch to create. The Test and
 * its parent-child link are two separate server calls, so "created" and "linked" are two separate
 * answers and the caller must be able to tell them apart when it reports back.
 */
export enum IntelliCatchTestCreateOutcome {
  CreatedAndLinked = 'createdAndLinked',
  CreatedNotLinked = 'createdNotLinked',
  ParentMissing = 'parentMissing',
  NotCreated = 'notCreated',
}
